import { render, staticRenderFns } from "./switchBox.vue?vue&type=template&id=48c2c3a3&scoped=true"
import script from "./switchBox.vue?vue&type=script&lang=js"
export * from "./switchBox.vue?vue&type=script&lang=js"
import style0 from "./switchBox.vue?vue&type=style&index=0&id=48c2c3a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c2c3a3",
  null
  
)

export default component.exports